import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { Department } from "../master-data/master-data.model";
import { FormBuilder, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MasterDataService } from "../master-data/master-data-service";
import { ActivatedRoute, Router } from "@angular/router";
import { finalize, takeUntil } from "rxjs/operators";
import { ItemEditComponent } from "../item-edit/item-edit.component";
import {
  ConfDialogType,
  ConfirmDialogModel,
} from "../shared/confirm-dialog/confim-dialog.model";
import {
  CONFIRM_DIALOG_MESSAGE,
  CONFIRM_DIALOG_MESSAGE_DELETE,
} from "../../locale/consts.en";
import { ConfirmDialogComponent } from "../shared/confirm-dialog/confirm-dialog.component";
import { DepartmentsService } from "./departments.service";
import { Subject } from "rxjs";

@Component({
    selector: "app-departments",
    templateUrl: "./departments.component.html",
    styleUrls: ["./departments.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DepartmentsComponent implements OnInit, OnDestroy {
  private dialog = inject(MatDialog);
  private departmentService = inject(DepartmentsService);
  private masterdataSerivce = inject(MasterDataService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private fb = inject(FormBuilder);

  departments: Department[] = [];
  private destroyed$ = new Subject();
  departmentsForm = this.fb.group({
    name: [null, [Validators.required]],
    externalId: [null],
  });

  ngOnInit(): void {
    this.departmentService.departments$
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (depts) => {
          this.departments = depts;
        },
      });
  }

  saveDepartmentToApi(dept: Department) {
    this.departmentService
      .updateDepartment(dept)
      .pipe(
        finalize(() => {
          this.departmentService.getDepartments();
        })
      )
      .subscribe({
        next: (response) => {
          this.masterdataSerivce.handleResponse(response);
        },
        error: (err) => this.masterdataSerivce.savingErrorMessage(),
      });
  }

  updateDepartment(d: Department) {
    const priority = new Department();
    Object.assign(priority, d);
    const dialogRef = this.dialog.open(ItemEditComponent, {
      width: "20vw",
      data: priority,
    });
    dialogRef.afterClosed().subscribe(async (data: Department) => {
      if (data != null) {
        this.saveDepartmentToApi(data);
      }
    });
  }

  deleteDepartment(department: Department) {
    const dialogData = new ConfirmDialogModel(
      CONFIRM_DIALOG_MESSAGE,
      CONFIRM_DIALOG_MESSAGE_DELETE,
      ConfDialogType.MESSAGE
    );
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
  }

  onAddDepartment() {
    const department = new Department();
    const dialogRef = this.dialog.open(ItemEditComponent, {
      width: "20vw",
      data: department,
    });
    dialogRef.afterClosed().subscribe(async (data: Department) => {
      if (data != null) {
        this.saveDepartmentToApi(data);
      }
    });
  }

  onBack() {
    this.router.navigate(["/"]).then();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(1);
    this.destroyed$.complete();
  }
}
